export default __webpack_public_path__ + "static/media/prudential-logo.d3d8cdd8.png";